import fetch from "./fetch";
/**
 * 直播相关接口
 */
const meeting = {
  // 直播列表
  liveRequst(data) {
    return fetch({
      isLoading: true,
      url: "/live/page",
      method: "GET",
      params: data,
    });
  },
  // 新增直播
  saveAndUpdate(data) {
    return fetch({
      isLoading: true,
      url: "/live/saveAndUpdate",
      method: "POST",
      data,
    });
  },

  // 直播详情
  liveDetailRequst(data) {
    return fetch({
      isLoading: true,
      url: "/live/detail",
      method: "GET",
      params: data,
    });
  },

  // 直播模糊查询
  selectListMessageRequst(data) {
    return fetch({
      isLoading: false,
      url: "/live/selectList",
      method: "GET",
      params: data,
    });
  },
  // 直播预览
  previewRequst(data) {
    return fetch({
      isLoading: true,
      url: "/live/preview",
      method: "GET",
      params: data,
    });
  },
  // 发布/下线
  publishRequst(data) {
    return fetch({
      isLoading: true,
      url: "/live/publish",
      method: "POST",
      data,
    });
  },
  // 删除直播
  removeRequst(data) {
    return fetch({
      isLoading: true,
      url: "/live/remove",
      method: "POST",
      data,
    });
  },
  // 手动推流
  pushRequst(data) {
    return fetch({
      isLoading: true,
      url: "/live/push",
      method: "POST",
      data,
    });
  },
  // 消息管理
  messageRequst(data) {
    return fetch({
      isLoading: true,
      url: "/message/page",
      method: "GET",
      params: data,
    });
  },

  // 禁言/取消禁言
  shutUpRequst(data) {
    return fetch({
      isLoading: true,
      url: "/message/shutUp",
      method: "POST",
      data,
    });
  },
  // 消息屏蔽\取消屏蔽
  shieldRequst(data) {
    return fetch({
      isLoading: true,
      url: "/message/shield",
      method: "GET",
      params: data,
    });
  },

  // 申请列表
  applyRequst(data) {
    return fetch({
      isLoading: true,
      url: "/meet/page",
      method: "GET",
      params: data,
    });
  },
  // 会议详情
  meetDetailRequst(data) {
    return fetch({
      isLoading: true,
      url: `/meet/selectDetail`,
      method: "GET",
      params: data,
    });
  },
  // 医院
  representativeDetailRequst(id) {
    return fetch({
      isLoading: true,
      url: `/representative/${id}`,
      method: "GET",
      params: {},
    });
  },
  // 修改
  meetUpdateRequst(data) {
    return fetch({
      isLoading: true,
      url: `/meet/update`,
      method: "POST",
      data,
    });
  },
  // 上传
  uploadImageRequst(data) {
    return fetch({
      isLoading: true,
      url: `/file-data/upload`,
      method: "POST",
      data,
    });
  },
  // 绑定直播
  bindLiveRequst(data) {
    return fetch({
      isLoading: true,
      url: `/meet/bindLive`,
      method: "POST",
      data,
    });
  },

  // 会务系统会议管理分页
  getMeetingManageList(params) {
    return fetch({
      isLoading: true,
      url: "/academicConference/page",
      method: "GET",
      params,
    });
  },

  // 会务系统会议管理查询已经绑定过会议的城市
  getCheckCity(params) {
    return fetch({
      isLoading: true,
      url: "/academicConference/checkCity",
      method: "GET",
      params,
    });
  },

  //会务系统会议管理新增/修改
  saveMeetingManage(data) {
    return fetch({
      isLoading: true,
      url: "/academicConference/saveAndUpdate",
      method: "POST",
      data,
    });
  },

  // 会务系统会议管理详情
  getMeetingManageDetail(params) {
    return fetch({
      isLoading: true,
      url: "/academicConference/detail",
      method: "GET",
      params,
    });
  },

  // 会务系统会议管理关联课程
  getRelatedCourse(params) {
    return fetch({
      isLoading: true,
      url: "/v1/course/selectLike",
      method: "GET",
      params,
    });
  },

  // 会务系统会议管理关联文档
  getRelatedDocument(params) {
    return fetch({
      isLoading: true,
      url: "/document/selectLike",
      method: "GET",
      params,
    });
  },

  //消息管理发布消息
  liveSystemSendMessage(data) {
    return fetch({
      isLoading: true,
      url: "/message/release",
      method: "POST",
      data,
    });
  },

  //消息管理回复消息
  liveSystemReplyMessage(data) {
    return fetch({
      isLoading: true,
      url: "/message/reply",
      method: "POST",
      data,
    });
  },

  //营销互动分页
  liveSystemMarketPage(params) {
    return fetch({
      isLoading: true,
      url: "/market/page",
      method: "GET",
      params,
    });
  },

  //营销互动分页
  liveSystemMarketTypeList(params) {
    return fetch({
      isLoading: true,
      url: "/market/typeList",
      method: "GET",
      params,
    });
  },

  //营销互动新增编辑
  liveSystemMarketSave(data) {
    return fetch({
      isLoading: true,
      url: "/market/saveAndUpdate",
      method: "POST",
      data,
    });
  },

  //营销互动上下线
  liveSystemMarketStatus(data) {
    return fetch({
      isLoading: true,
      url: "/market/onlineOrOffline",
      method: "POST",
      data,
    });
  },

  //营销互动删除
  liveSystemMarketDelete(data) {
    return fetch({
      isLoading: true,
      url: "/market/delete",
      method: "POST",
      data,
    });
  },

  //营销互动启用禁用
  liveSystemMarketEnable(data) {
    return fetch({
      isLoading: true,
      url: "/market/enableOrDisable",
      method: "POST",
      data,
    });
  },

  //营销互动编辑tab
  liveSystemMarketTypeUpdate(data) {
    return fetch({
      isLoading: true,
      url: "/market/typeUpdate",
      method: "POST",
      data,
    });
  },
};

export default meeting;
